import Vue from 'vue';
import Router from 'vue-router';
import Splash from '@/components/Splash';
import Login from '@/modules/login/Login';
import Layout from '@/modules/admin/Layout';
import NotFoundComponent from '@/modules/admin/NotFoundComponent';
import PublicidadList from '@/modules/admin/publicidad/PublicidadList';
import PublicidadDetail from '@/modules/admin/publicidad/PublicidadDetail';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Splash',
      component: Splash,
    },
    {
      path: '/login',
      name: 'Iniciar Sesión',
      component: Login,
    },
    {
      path: '/admin',
      name: 'Panel Administrativo',
      meta: { requiresAuth: true, title: 'Inicio' },
      component: Layout,
      children: [
        {
          path: 'detail/',
          name: 'Detalle de Campaña',
          meta: { requiresAuth: true, title: 'Detalle de Campaña' },
          components: {
            main: PublicidadDetail,
          },
        },
        {
          path: 'campaigns/',
          name: 'Listado de Campañas',
          meta: { requiresAuth: true, title: 'Listado de Campañas' },
          components: {
            main: PublicidadList,
          },
        },
      ],
    },
    { path: '*', component: NotFoundComponent },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js